import { css } from 'styled-components';

export default {
  container: css`
    z-index: 200;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    bottom: 0;
    -webkit-box-pack: start;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-start;
    position: fixed;
    background-color: white;
    height: 55px;
    width: 100%;
    box-shadow: 0px 0px 2px 2px rgb(125 125 136 / 26%);
  `,

  imgContainer: css`
    border-radius: 10px;
    width: 35px;
    height: 35px;
    padding: initial;
    background-color: rgb(63, 42, 85);
    justify-content: center;
    align-items: center;
    display: flex;
    align-self: center;
    margin: 5px;
`,
  pinkButton: css`
    height: 32px;
    width: 'auto';
    border-radius: 5px;
    color: WHITE;
    background-color: rgb(240, 96, 163);
    padding: 7px 10px;
    justify-content: center;
    align-self: center;
    align-items: center;
    display: flex;
    text-align: center;
    font-size: 12px;
  `,

  text:  css`
    font-weight: bold;
    text-align: start;
    font-size: 12px;
    margin-inline-end: 40px;
    margin-inline-start: 5px;
    align-self: center;
  `,

  closeImg:  css`
    width: 15px;
    border: black;
    padding: 2px;
    height: 15px;
    border-width: 2px;
    border-radius: 30px;
    border: 1.5px solid black;
    justify-content: center;
    align-self: center;
    margin: 10px;
  `,
  
};
